// removed by extract-text-webpack-plugin
module.exports = {"fade":"components-Fade-__index__fade__3DMMR","in":"components-Fade-__index__in__CceQN","out":"components-Fade-__index__out__3jPWI"};


//////////////////
// WEBPACK FOOTER
// ./components/Fade/index.css
// module id = 792
// module chunks = 0